import { Alert, AlertProps } from '@carrotfertility/carotene-core';
import React from 'react';

export type FormAlertProps = AlertProps;

export function FormAlert(props: FormAlertProps) {
    return <Alert data-formalert={props.severity} {...props} />;
}
